function getPrices(handle){
  return new Promise(function (resolve, reject) {
    if( window.priceMapping[handle] ) {
      resolve(window.priceMapping[handle])
    } else {
      fetch('/api/2025-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '9e47d5274e000d20bf97970e94729b87' 
        },
        body: JSON.stringify({
          "query": `query product @inContext(country: ${window.localizationIso}) {
            product: productByHandle(handle: "${handle}") {
              variants(first: 250) {
                nodes {
                  availableForSale
                  price {
                    amount
                  }
                  compareAtPrice {
                    amount
                  }
                }
              }
            }
          }`
        })
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        if( response && response.data && response.data.product ) {
          const availableVariants = response.data.product.variants.nodes.filter( (variant) => { return variant.availableForSale } )
          const variant = availableVariants[0] ? availableVariants[0] : response.data.product.variants[0]
          const price = {
            price: variant.price ? variant.price.amount * 100 : null,
            compare_at_price: variant.compareAtPrice ? variant.compareAtPrice.amount * 100 : null
          }
          window.priceMapping[handle] = price
          resolve(price)
        } else {
          console.log('Error!', response)
          resolve(false)
        }
      });
    }
  })
}

const updateSearchPrices = (mutationList, observer) => {
  document.querySelectorAll('.boost-pfs-filter-wrapper .product-card:not(.price-fixed)').forEach(function(product){
    const link = product.querySelector('a[href*="products/"]')
    const handle = link.getAttribute('href').split('products/')[1].split('?')[0]
    getPrices(handle).then(function(prices){
      const pricingWrap = product.querySelector('.itemPrice.price-item')
      if( pricingWrap ) {
        const compareAtPrice = (prices.compare_at_price && prices.compare_at_price > prices.price) ? prices.compare_at_price : prices.price
        const compareWrap = pricingWrap.querySelector('[data-regular-price]');
        const priceWrap = pricingWrap.querySelector('[data-sale-price]');
        if( compareWrap ) {
          if( compareWrap.querySelector('small') ) {
            compareWrap.innerHTML = compareWrap.querySelector('small').outerHTML + theme.Currency.formatMoney(compareAtPrice, theme.moneyFormat)
          } else {
            compareWrap.innerHTML = theme.Currency.formatMoney(compareAtPrice, theme.moneyFormat)
          }
        }
        if( priceWrap ) {
          priceWrap.innerHTML = theme.Currency.formatMoney(prices.price, theme.moneyFormat)
        }
        product.classList.add('price-fixed')
      }
    })
  });

  document.querySelectorAll('.boost-pfs-search-suggestion-item-product:not(.price-fixed)').forEach(function(product){
    const link = product.querySelector('a[href*="products/"]')
    const handle = link.getAttribute('href').split('products/')[1].split('?')[0]
    getPrices(handle).then(function(prices){
      const pricingWrap = product.querySelector('.boost-pfs-search-suggestion-product-price')
      if( pricingWrap ) {
        if( prices.compare_at_price ) {
          pricingWrap.innerHTML = `<span class="boost-pfs-search-suggestion-product-sale-price">${theme.Currency.formatMoney(prices.price, theme.moneyFormat)}</span><s>${theme.Currency.formatMoney(prices.compare_at_price, theme.moneyFormat)}</s>`
        } else {
          pricingWrap.innerHTML = `<span class="boost-pfs-search-suggestion-product-regular-price">${theme.Currency.formatMoney(prices.price, theme.moneyFormat)}</span>`
        }
        product.classList.add('price-fixed')
      }
    })
  })
};
const searchPriceObserver = new MutationObserver(updateSearchPrices);
searchPriceObserver.observe(document.querySelector('body'), { childList: true, subtree: true });